import React, { useEffect, useRef } from 'react';
import { alias, extend, useLazyDataModel, string as stringType } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { productPageImport } from '../pages/browse-search/dynamic-imports';

export const usePrefetchPip = (shouldPrefetchPip, varnish, storeZip) => {
  const { storeId } = useStore({ varnish, online: false });

  const timeoutRef = useRef(null);
  const productPageChunkLoaded = useRef(false);
  const prefetchedSkuSet = useRef(new Set());
  const prefetchPipRef = useRef({
    prefetchPip: alias('product').params({ itemId: stringType().isRequired() }).shape({
      itemId: stringType()
    }),
    prefetchPipClient: alias('product').params({ itemId: stringType().isRequired() }).shape({
      itemId: stringType()
    })
  });

  const dataModelCombo = extend({}, prefetchPipRef.current.prefetchPip, prefetchPipRef.current.prefetchPipClient);

  const [productRequestClient] = useLazyDataModel('prefetchPipClient', {
    fetchPolicy: 'cache-first',
    dataModel: { prefetchPipClient: dataModelCombo },
    skip: true,
    variables: { storeId, dataSource: 'catalog' }
  });

  const fetchProductInfo = (itemId) => {
    if (shouldPrefetchPip === 'both' || shouldPrefetchPip === 'clientOnly') {
      productRequestClient({
        variables: {
          itemId,
          dataSource: 'catalog',
          storeId,
          zipCode: storeZip
        }
      });
    }
    // is this supposed to be added even when prefetchPip is off?
    prefetchedSkuSet.current.add(itemId);
  };

  const loadProductPageChunk = async () => {
    if (!productPageChunkLoaded.current) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      const productPage = await productPageImport();
      prefetchPipRef.current = productPage?.ProductDataModel;
      productPageChunkLoaded.current = true;
    }
  };

  const prefetchProductInfo = async (itemId) => {
    if (shouldPrefetchPip) await loadProductPageChunk();
    fetchProductInfo(itemId);
  };

  useEffect(() => {
    if (shouldPrefetchPip) {
      timeoutRef.current = setTimeout(() => {
        loadProductPageChunk().catch()
      }, 5000);
    }
  }, []);

  return {
    loadProductPageChunk,
    prefetchProductInfo,
    productPageChunkLoaded,
  }
};
